<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 점검정보 -->
    <div>
      <vs-row class="my-4">
        <vs-col>
          <h5><i class="dot"></i>{{ $t('기본정보') }}</h5>
        </vs-col>
      </vs-row>
      <div
        class="grid flex-wrap"
        style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem"
      >
        <vs-row
          class="mb-4"
          style="display: grid; grid-template-columns: 128px 1fr"
          vs-align="center"
        >
          <vs-col>{{ $t('담당부서') }}</vs-col>
          <vs-col>
            <span v-if="isPrint" class="print-input">
              {{ form.inputA_1 }}
            </span>
            <company-selector
              v-else
              v-model="form.inputA_0"
              :company-name="form.inputA_1"
              @select="targetCompany"
              :readonly="board.readonly"
              class="w-full flex-1"
            />
          </vs-col>
        </vs-row>
        <vs-row
          class="mb-4"
          style="display: grid; grid-template-columns: 128px 1fr"
          vs-align="center"
        >
          <vs-col>{{ $t('점검자명') }}</vs-col>
          <vs-col>
            <span v-if="isPrint" class="print-input">
              {{ form.inputA_2 }}
            </span>
            <ml-input
              v-else
              :readonly="board.readonly"
              class="w-full flex-1"
              placeholder="입력필드"
              v-model="form.inputA_2"
            />
          </vs-col>
        </vs-row>
        <vs-row
          class="mb-4"
          style="display: grid; grid-template-columns: 128px 1fr"
          vs-align="center"
        >
          <vs-col>{{ $t('점검일') }}</vs-col>
          <vs-col>
            <span v-if="isPrint" class="print-input">
              {{ form.inputA_3 }}
            </span>
            <date-selector
              v-else
              :readonly="board.readonly"
              placeholder="날짜선택"
              class="w-full flex-1"
              v-model="form.inputA_3"
            />
          </vs-col>
        </vs-row>
      </div>
    </div>

    <!-- 구분 -->
    <div class="mb-8">
      <vs-row class="my-4">
        <vs-col class="flex items-center">
          <h5><i class="dot"></i>{{ $t('구분') }}</h5>
        </vs-col>
      </vs-row>
      <vs-row class="grid grid-cols-12">
        <vs-col class="col-span-2">
          <div v-if="isPrint || board.readonly" class="flex items-center">
            <div
              v-if="form.inputA_4 === '상반기'"
              style="background: #200c63"
              class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
            >
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div
              v-else
              style="border: 2px solid rgb(180, 180, 180)"
              class="w-5 h-5 rounded-sm mr-2"
            ></div>
            <span class="flex-1">{{ $t('상반기') }}</span>
          </div>
          <div v-else>
          <span class="flex"><vs-checkbox v-model="form.inputA_4" vs-value="상반기" />{{ $t('상반기') }}</span>
          </div>
        </vs-col>
        <vs-col>
          <div v-if="isPrint || board.readonly" class="flex items-center">
            <div
              v-if="form.inputA_4 === '하반기'"
              style="background: #200c63"
              class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
            >
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div
              v-else
              style="border: 2px solid rgb(180, 180, 180)"
              class="w-5 h-5 rounded-sm mr-2"
            ></div>
            <span class="flex-1">{{ $t('하반기') }}</span>
          </div>
          <div v-else>
            <span class="flex"><vs-checkbox v-model="form.inputA_4" vs-value="하반기" />{{ $t('하반기') }}</span>
          </div>
        </vs-col>
      </vs-row>
    </div>


    <!-- 업무 수행 여부 -->
    <div>
      <vs-row class="my-4">
        <vs-col class="flex items-center">
          <h5><i class="dot"></i>{{ $t('업무 수행 여부') }}</h5>
          <div class="flex items-center cursor-pointer" @click="openPopup">
            <feather-icon
              icon="AlertCircleIcon"
              class="ml-6 mr-1"
              style="cursor: pointer; width: 18px; color: #7e72f2"
            />
            <span style="color: #7e72f2">{{ $t('이행사항 점검 시 작성요령') }}</span>
          </div>
        </vs-col>
      </vs-row>
      <table-inspect
        class="mt-5"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="false"
        :is-note="true"
        table-header-yes="양호"
        table-header-no="미흡"
        table-header-na="해당없음"
        table-header-note="개선요망 사항"
        footer="※ (중처법=중대재해처벌 등에 관한 법률. 산안법=산업안전보건법)"
        v-model="form.inspectList"
      />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    />

    <!-- 이행사항 점검 시 작성요령 팝업 -->
    <vs-popup
      id="popAlert"
      title="이행사항 점검 시 작성요령"
      :active.sync="showPopup"
    >
      <table id="PopupTable" style="margin-bottom: 20px;">
        <tr>
          <th>{{ $t('증빙자료 첨부') }}</th>
        </tr>
        <tr>
          <td class="p-3 font-bold">{{ $t('반드시 증빙자료 첨부 필요') }}</td>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2">{{ $t('증빙자료 예시') }}</b>
            <ul>
              <li class="mb-1">{{ $t('연번 1  : 사업장을 담당하는 관리부서 담당자의 업무사항이 나와있는 자료(업무사항에 반드시 ‘') }}<span style="color: #0029ff; text-decoration: underline;">{{ $t('사업장 안전보건 관리’에 대한 내용이 명시되어 있어야 함') }}</span>{{ $t('. 업무분장표를 제출할 경우, 하이라이트 등을 이용하여 담당자 명시 필수)') }}</li>
              <li class="mb-1">{{ $t('연번 2 : 안전보건 관련 예산(ex, 안전보건 유지관리를 위한 용역,위탁,운영비 등 관리부서의 안전보건 예산)') }}</li>
              <li class="mb-1">{{ $t('연번 3 : (1)') }}<span style="color: #0029ff; text-decoration: underline;">{{ $t('원료, 제조물 표준 점검표 등을 이용한 유해·위험요인 점검결과') }}</span>{{ $t('및 기타 점검결과 자료(월별 점검표 등)') }}<br/>
                　　 　 (2) 유해위험요인 처리 절차, 중대시민재해 발생 대응 매뉴얼(담당자 표시된 것), 재해발생시 보고절차
              </li>
              <li class="mb-1">{{ $t('연번 4 : 『중대시민재해 이행사항 점검표』 제출로 갈음. 기타 법령상에 따른 의무사항이 있을 경우, 추가 첨부') }}</li>
              <li class="mb-1">{{ $t('연번 5 :') }}<span style="color: #0029ff; text-decoration: underline;">{{ $t('법정 의무교육 이수증') }}</span>{{ $t('및 이수 계획') }}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td style="text-align: center; font-size: 14px; line-height: 24px; color: #0029ff;font-weight: 700;padding: 14px;">{{ $t('* 필독!!') }}<br/>
            자체점검 결과가 ‘보통’인 사항은 비고란에 <span style="color: #e42728; text-decoration: underline;">{{ $t('미이행사항 및 개선 조치 계획') }}</span>{{ $t('등을 기재,') }}<br/>
            ‘미흡’인 사항에 대해서는 <span style="color: #e42728; text-decoration: underline;">{{ $t('미이행사항 및 개선 조치 계획') }}</span>{{ $t('보완 조치 계획, 재점검 계획 등을 별도로 첨부') }}</span>{{ $t('하여 제출') }}</td>
        </tr>
      </table>
    </vs-popup>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from "@/components/TableInspectNo";
import DateSelector from "@/components/selector/DateSelector";
import CompanySelector from "@/components/selector/CompanySelector";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    DateSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        fileList: [],
        inspectList: [
          {
            label: "필요한 안전인력 확보 [중처법 제10조제1호]",
            chlid: [
              {
                label: "시설 안전보건 조치 업무 담당",
                is_checked: "",
              },
              {
                label: "시설설비 유지보수 업무 관리",
                is_checked: "",
              },
            ],
          },
          {
            label: "필요한 안전예산 편성·집행 [중처법 제10조제2호]",
            chlid: [
              {
                label: "안전보건 관련 인건비",
                is_checked: "",
              },
              {
                label: "시설장비 안전 확보 유지관리비",
                is_checked: "",
              },
              {
                label: "안전점검비",
                is_checked: "",
              },
              {
                label: "기타비용",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전점검 계획 수립·시행 [중처법 제10조제3호]",
            chlid: [
              {
                label: "정기안전점검",
                is_checked: "",
              },
              {
                label: "정밀안전점검",
                is_checked: "",
              },
              {
                label: "정밀안전진단",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전계획 수립·시행 [중처법 제10조제4호]",
            chlid: [
              {
                label: "인력확보",
                is_checked: "",
              },
              {
                label: "예산확보",
                is_checked: "",
              },
              {
                label: "점검계획 수립 및 이행여부",
                is_checked: "",
              },
              {
                label: "유지관리 계획 및 시행",
                is_checked: "",
              },
            ],
          },
          {
            label: "재해예방 업무처리 절차 마련·이행 [중처법 제10조제7호]",
            chlid: [
              {
                label: "유해위협요인 점검",
                is_checked: "",
              },
              {
                label: "유해위협요인 발견 시 조치",
                is_checked: "",
              },
              {
                label: "재해 발생 시 대응 절차 및 매뉴얼",
                is_checked: "",
              },
              {
                label: "비상대피훈련 계획 등",
                is_checked: "",
              },
            ],
          },
          {
            label: "도급·용역·위탁 기준과 절차 마련·이행 [중처법 제10조제8호]",
            chlid: [
              {
                label: "도급·용역·위탁 시 평가기준 및 절차 마련 및 이행여부 확인",
                is_checked: "",
              },
            ],
          },
          {
            label:
              "안전보건 관계 법령 의무이행 점검 [중처법 제11조제2항제1호, 2호]",
            chlid: [
              {
                label: "의무이행사항 점검",
                is_checked: "",
              },
              {
                label: "미이행 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
          {
            label:
              "안전관리자/종사자교육 시행 점검 [중처법 제11조제2항제3호, 4호]",
            chlid: [
              {
                label: "교육 이수 점검",
                is_checked: "",
              },
              {
                label: "미이수 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
        ],
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: [],
      },
    };
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    targetCompany(value) {
      this.form.inputA_1 = value.com_name;
    },
  },
};
</script>

<style scoped lang="scss">
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  li {
    margin-left: 16px;
    &::marker {
      content: " · ";
      font-size: 1.2em;
    }
  }
}
</style>
